import React from 'react';
import {useRegisterSW} from 'virtual:pwa-register/react';
import {useOfflineQueue} from '../hooks/useOfflineQueue';
import {useCaptureSafety} from '../contexts/CaptureSafetyContext';
import {getPwaUpdateBlocker} from '../lib/pwa/pwaSafety';
import Button from './ui/Button';

export default function PwaUpdateNotice() {
  const {needRefresh: [ready], updateServiceWorker} = useRegisterSW();
  const {draftCount, isSyncing} = useOfflineQueue();
  const {hasUnsavedCapture} = useCaptureSafety();
  if (!ready) return null;
  const blocker = getPwaUpdateBlocker({hasUnsavedCapture, draftCount, isSyncing});
  return <section className="mx-4 mt-4 flex flex-wrap items-center justify-between gap-3 rounded-2xl border border-teal-200 bg-mint p-4 sm:mx-6 lg:mx-10" aria-label="App update">
    <div className="min-w-0" role="status" aria-live="polite">
      <p className="text-sm font-semibold text-ink">An app update is ready.</p>
      <p className="mt-1 text-xs leading-5 text-slate-600">{blocker || 'Update now to use the latest secure version of SilaTrail.'}</p>
    </div>
    <Button disabled={Boolean(blocker)} aria-describedby={blocker ? 'pwa-update-blocker' : undefined} onClick={() => updateServiceWorker(true)}>Update app</Button>
    {blocker && <span id="pwa-update-blocker" className="sr-only">{blocker}</span>}
  </section>;
}
